<div class="content">
  <glxy-label class="info-message">{{ 'AUTOMATIONS.EDITOR.TASKS.UPDATE_CONTACT.INFO' | translate }}</glxy-label>
  <ng-container *ngIf="components$ | async as components">
    <div class="inputs" *ngFor="let formControl of formArray.controls; let i = index">
      <automata-data-entry
        [dataEntryOptions]="components"
        [dontIncludeDefaultCategories]="false"
        [formControl]="formControl"
        (remove)="removeDataEntryComponent(i)"
      ></automata-data-entry>
    </div>
  </ng-container>

  <div>
    <button mat-button color="primary" (click)="addDataEntryComponent()">
      {{ 'AUTOMATIONS.EDITOR.TASKS.UPDATE_COMPANY.ADD_ADDITIONAL_FIELDS' | translate }}
    </button>
  </div>
</div>
